import styled, { keyframes } from 'styled-components';

// Task 36 — TD İK/yönetim Dashboard'u. performance-dashboard/styles.js (Task 32)
// İLE AYNI kart/grid deseni — bağımsız kopya (repo konvansiyonu: her dashboard
// klasörü kendi stil dosyasını taşır). Renkler YALNIZ tema token'larından gelir
// (hardcode YASAK, bkz. task-32 brief'i ve bu görevin brief'i).

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PageWrap = styled.div`
  padding: 0;
`;

export const FilterRow = styled.div`
  max-width: 280px;
  margin-bottom: 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(${({ theme }) => theme.colors.shadow.rgb}, 0.06);
  padding: 20px;
  grid-column: span ${({ $span }) => $span || 4};
  animation: ${fadeIn} 0.4s ease-out both;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-column: span ${({ $spanMd }) => $spanMd || 6};
  }
  @media (max-width: 768px) {
    grid-column: span 1;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
`;

export const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const CardMeta = styled.span`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 120px;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  text-align: center;
`;

export const Skeleton = styled.div`
  flex: 1;
  min-height: 120px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.surface.border};
  opacity: 0.5;
`;

export const ListRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface.border};

  &:last-child { border-bottom: none; }
`;

export const RowMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RowName = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProgressTrack = styled.div`
  flex: 1;
  height: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.surface.border};
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  width: ${({ $pct }) => Math.min(100, Math.max(0, $pct || 0))}%;
  height: 100%;
  border-radius: 4px;
  background: ${({ $color }) => $color};
`;

export const StatLabel = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.muted};
  margin-bottom: 6px;
`;

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const StatRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
`;

export const StatSub = styled.span`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

// TD-17 — k-anonimlik dipnotu: grafiğin ALTINDA, sessizce. "Bu hücrede kimse yok"
// ile "bu hücre gizlendi" arasındaki farkı kullanıcının görmesi ZORUNLU; aksi halde
// bastırma, veriyi yanlış okutan bir sessizliğe dönüşür.
export const PrivacyNote = styled.div`
  margin-top: 10px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  line-height: 1.4;
`;

// ---------------------------------------------------------------------------
// PoolStatusCard — etiket dağılımı çipleri (task 36 YENİ, diğer kartlarda
// karşılığı yok — auxiliar.purple, eski TalentDashboardPage'in havuz vurgu
// rengiyle AYNI, bkz. o dosyanın useAccents yorumu).
// ---------------------------------------------------------------------------

export const TagChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagChip = styled.span`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.auxiliar.purple};
  background: ${({ theme }) => `${theme.colors.auxiliar.purple}1A`};
  border-radius: 999px;
  padding: 3px 10px;
  white-space: nowrap;
`;

// ---------------------------------------------------------------------------
// FlightRiskDistributionCard — tek çubuklu parça-bütün gösterimi (task 36
// YENİ). Segmentler arası 2px yüzey boşluğu (dataviz kuralı — marks-and-
// anatomy: "2px surface gap between fills").
// ---------------------------------------------------------------------------

export const SegmentBar = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  height: 14px;
  border-radius: 7px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.border};
`;

export const SegmentFill = styled.div`
  height: 100%;
  border-radius: 3px;
`;

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 12px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const LegendDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
`;
